import { MenuItem, MenuItemWithSubMenu } from '@/types.d';

const menuItems: (MenuItem | MenuItemWithSubMenu)[] = [
  {
    title: 'Our story & team',
    href: '/our-story',
    subMenu: [
      {
        title: 'News',
        href: '/news',
      },
      {
        title: 'Writings',
        href: '/writings',
      },
      {
        title: 'Links',
        href: '/our-story#links',
      },
    ],
  },
  {
    // No bare `/services` page to point at any more, so "Services" is a label
    // that opens its dropdown — the same shape as "Toolbox". (#52)
    title: 'Services',
    href: null,
    subMenu: [
      {
        title: 'Hamtramck Center',
        href: '/services/hamtramck-center',
        subMenu: [
          {
            title: 'Events',
            href: '/services/hamtramck-center#events',
          },
          {
            title: 'Recovery coaching',
            href: 'https://calendly.com/passengerrecovery',
            target: '_blank',
          },
        ],
      },
      {
        title: 'Downriver Center',
        href: '/services/downriver-center',
        subMenu: [
          {
            title: 'Events',
            href: '/services/downriver-center#events',
          },
          {
            title: 'Recovery coaching',
            href: 'https://calendly.com/passengerrecovery-downriver/30min',
            target: '_blank',
          },
        ],
      },
    ],
  },
  {
    title: 'Toolbox',
    href: null,
    subMenu: [
      {
        title: 'Online resources',
        href: '/resources',
      },
      {
        title: 'Partners',
        href: '/resources#partners',
      },
      {
        title: 'Online meetings',
        href: '/online-meetings',
      },
      {
        title: 'Thought of the day',
        href: 'https://www.hazeldenbettyford.org/thought-for-the-day',
        target: '_blank',
      },
    ],
  },
  {
    title: 'Find a meeting',
    href: '/compass',
  },
  {
    title: 'Contact us',
    href: '/contact',
  },
];

const adminMenuItems = [
  {
    title: 'Admin home',
    compactTitle: 'Home',
    href: '/compass/admin',
    type: 'none',
    group: 'Workspace',
  },
  {
    title: 'Scrape review',
    compactTitle: 'Scrape',
    href: '/compass/admin/scrape-review',
    type: 'scrape-review',
    group: 'Reviews',
  },
  {
    title: 'Reported meetings',
    compactTitle: 'Reports',
    href: '/compass/admin/reported-meetings',
    type: 'reports',
    group: 'Reviews',
  },
  {
    title: 'Edit meetings',
    compactTitle: 'Edit',
    href: '/compass/admin/edit-meetings',
    type: 'edit',
    group: 'Meetings',
  },
  {
    title: 'Add meetings',
    compactTitle: 'Add',
    href: '/compass/admin/add-meeting',
    type: 'add',
    group: 'Meetings',
  },
  {
    title: 'Upload meetings',
    compactTitle: 'Upload',
    href: '/compass/admin/upload-meetings',
    type: 'upload',
    group: 'Meetings',
  },
];

export { menuItems, adminMenuItems };
